<template>
  <div class="umesr-rows-list">
    <div
      v-for="(item, index) in value"
      :key="`umesr-rows-list-${index}`"
      :class="`umesr-rows-list__item umesr-rows-list__item__index-${index}`"
    >
      <custom-callout
        :border-color="getColor(item.statuCode)"
        class="mb-3 callout"
        :controlled="true"
        :opened="item.isOpen"
        @click:open="onOpenDetails(value[index], index)"
      >
        <row-standard
          :index="index"
          :value="item"
          @on-delete="onDeleteHandler"
        />
        <!-- Tabs -->
        <template #edition>
          <additional-info :value="item" />
        </template>
      </custom-callout>
    </div>
  </div>
</template>

<script>
import RowStandard from './RowStandard';
import { Colors } from '@/components/common';
import AdditionalInfo from './AdditionalInfo';
import statusEnum from '@/views/scholarship/attendance/utils/statusEnum.js';
import CustomCallout from 'custom-callout';

export default {
  components: {
    RowStandard,
    AdditionalInfo,
    CustomCallout,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getColor(status) {
      switch (status) {
        case statusEnum.payment:
          return 'primary-15';
        case statusEnum.approved:
          return 'green-light';
        case statusEnum.pending:
        case statusEnum.no_payment:
          return Colors.YELLOW;
        case statusEnum.denegate:
          return Colors.BROWN;
        default:
          return 'secondary-19';
      }
    },
    onOpenDetails(rowItem, rowIndex) {
      this.value.map((item, index) => {
        if (index === rowIndex) {
          item.isOpen = !item.isOpen;
        } else {
          item.isOpen = false;
        }
        return item;
      });
    },
    async onDeleteHandler(id) {
      this.$emit('on-delete', id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';

::v-deep .custom-nav-container {
  // border-bottom: 1px solid map-get($colors, 'gray-5');
  margin-left: 20px;
  margin-right: 20px;
  .nav-item {
    .nav-link {
      font-size: 14px;
      color: map-get($colors, 'gray-7');
      padding-right: 70px;
      padding-left: 45px;

      &.active:after {
        content: unset;
      }
    }
  }
}
</style>
